import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiClient } from '@/lib/api/client';
import { useTenantStore } from '@/stores/tenantStore';

import type { CreateWorkflowInput } from '../schemas/workflowSchemas';
import { workflowKeys } from './workflowKeys';

interface CreateWorkflowResponse {
  id: string;
}

export function useCreateWorkflow() {
  const qc = useQueryClient();
  const tenantId = useTenantStore((s) => s.tenantId);

  return useMutation({
    mutationFn: (body: CreateWorkflowInput) =>
      apiClient
        .post(`api/v1/t/${tenantId}/workflows`, { json: body })
        .json<CreateWorkflowResponse>(),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: workflowKeys.lists() });
    },
  });
}
